<div class="relative h-0.7pt w-full">
  <div class="absolute inset-0 flex flex-row -mx-1/5">
    <div class="w-1/7 bg-gradient-(from-current to-transparent to-l)" />
    <div class="w-5/7 bg-current" />
    <div class="w-1/7 bg-gradient-(from-current to-transparent to-r)" />
  </div>
</div>
